import { useEffect } from 'react';

type MaybeRef = React.RefObject<HTMLElement | null> | null | undefined;

/*
Fecha um painel quando o FOCO sai de todas as áreas informadas — o par de
`useOnClickOutside` para o teclado.

Sem isto, quem abria o mega menu com Enter e seguia com Tab passava pelos
itens do painel e, no Tab seguinte, o foco ia para o conteúdo atrás do painel,
que continuava aberto cobrindo o elemento focado (bug 11145). Fechar ao sair é
o comportamento de menu: não se prende o foco (não é um diálogo), mas o painel
não pode ficar aberto tapando onde o usuário está.

`focusin` sobe pelo documento (ao contrário de `focus`), por isso um ouvinte
só no `document` basta.
*/
export const useFocusOutside = (
  active: boolean,
  refs: MaybeRef[],
  onOutside: () => void,
) => {
  useEffect(() => {
    if (!active) return undefined;

    const handleFocusIn = (event: FocusEvent) => {
      const target = event.target as Node;
      const inside = refs.some((ref) => ref?.current?.contains(target));
      if (!inside) onOutside();
    };

    document.addEventListener('focusin', handleFocusIn);
    return () => document.removeEventListener('focusin', handleFocusIn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, onOutside, ...refs]);
};

export default useFocusOutside;
